<template>
  <div class="lc-container">
    <div id="search-form" class="form-wrap">
      <common-search-form-wrapper :reset="resetSearch">
        <el-form size="mini" :model="searchInfo" label-width="64px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="班级名称:" prop="class">
                <el-select
                  v-model="searchInfo.class_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchClass"
                  @change="handleSearch"
                  @focus="handleSearchClass('')"
                >
                  <el-option
                    v-for="item in classList"
                    :key="item.class_id"
                    :label="item.name"
                    :value="item.class_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- 暂时注释，看教务那边是否需要 -->
            <!-- <el-col :span="8">
            <el-form-item label="班级简称:" prop="class_sub">
              <el-select
                v-model="searchInfo.class_sub"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchClassBySub"
                @change="handleSearch"
                @visible-change="handleSearchClassBySubVisible"
                @clear="handleSearch"
              >
                <el-option
                  v-for="(item, index) in SubClassList"
                  :key="index"
                  :label="item.sub_name"
                  :value="item.class_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
            <el-col :span="8">
              <el-form-item label="排课课程:" prop="course_id">
                <el-select
                  v-model="searchInfo.course_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchCourse"
                  @focus="handleSearchCourse('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in courseList"
                    :key="item.course_id"
                    :label="item.title"
                    :value="item.course_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课教师:" prop="teacher_id">
                <common-staff-pull-down
                  :originId.sync="searchInfo.teacher_id"
                  :defaultSelected.sync="searchInfo.teacher_list"
                  :multiple="true"
                  :jobIds="[1]"
                  @change="handleSearch"
                ></common-staff-pull-down>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课学员:" prop="student_id">
                <el-select
                  v-model="searchInfo.student_id"
                  filterable
                  clearable
                  placeholder="请选择"
                  :filter-method="handleSearchStudent"
                  @focus="handleSearchStudent('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in studentList"
                    :key="item.student_id"
                    :label="item.name"
                    :value="item.student_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="上课教室:" prop="classroom_id">
                <el-select
                  v-model="searchInfo.classroom_id"
                  filterable
                  clearable
                  multiple
                  placeholder="请选择"
                  :filter-method="handleSearchClassroom"
                  @focus="handleSearchClassroom('')"
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in classroomList"
                    :key="item.classroom_id"
                    :label="item.name"
                    :value="item.classroom_id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="授课模式:" prop="lesson_type">
                <el-radio-group
                  v-model="searchInfo.lesson_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">线下</el-radio-button>
                  <el-radio-button label="2">线上</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="点名状态:" prop="roll_call_status">
                <el-radio-group
                  v-model="searchInfo.roll_call_status"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="2">已点名</el-radio-button>
                  <el-radio-button label="1">未点名</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="班级类型:" prop="course_type">
                <el-radio-group
                  v-model="searchInfo.course_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">1vN</el-radio-button>
                  <el-radio-button label="2">1v1</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="到课状态:" prop="roll_call_student_status">
                <el-radio-group
                  v-model="searchInfo.roll_call_student_status"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">到课</el-radio-button>
                  <el-radio-button label="3">请假</el-radio-button>
                  <el-radio-button label="4">未到</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课次学员:" prop="student_type">
                <el-radio-group
                  v-model="searchInfo.student_type"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">临时</el-radio-button>
                  <el-radio-button label="5">体验</el-radio-button>
                  <el-radio-button label="3">补课</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="课次练习:" prop="lesson_exercise">
                <el-radio-group
                  v-model="searchInfo.lesson_exercise"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">已发布</el-radio-button>
                  <el-radio-button label="2">未发布</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="班级人数:"
                prop="class_student_full"
                v-if="Number(searchInfo.course_type) === 1"
              >
                <el-radio-group
                  v-model="searchInfo.class_student_full"
                  @change="handleSearch"
                >
                  <el-radio-button label="-1">全部</el-radio-button>
                  <el-radio-button label="1">满班</el-radio-button>
                  <el-radio-button label="2">未满班</el-radio-button>
                </el-radio-group>
                <el-popover
                  placement="top"
                  popper-class="followuppopover"
                  trigger="hover"
                >
                  <p>班级人数筛选只显示 “1vN”班级的情况</p>
                  <i
                    class="el-icon-question"
                    slot="reference"
                    style="margin-left: 8px; color: #bebfc0"
                  ></i>
                </el-popover>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </common-search-form-wrapper>
    </div>
    <div class="lc-header">
      <div class="float-print-wrap l2">
        <schedulePrintDialog
          :showTimeRange="showTimeRange"
          :printlnWeek_date="''"
          :classroom_ids="searchInfo.classroom_id"
        >
          <div class="float-print-button mwow-button success">周课表打印</div>
        </schedulePrintDialog>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="190"
        >
          <p>
            默认打印本周课表，如打印其他周，请切换至对应周时间；筛选条件会影响课表打印结果；
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: middle;
            "
          ></i>
        </el-popover>
      </div>
      <course-adjustment
        class="float-print-wrap"
        @courseAdjustment="renderCalendar"
      >
        <div class="float-print-button mwow-button success">快速调课</div>
      </course-adjustment>
      <del-course-dialog
        @handleDelCourse="renderCalendar"
        class="float-print-wrap l1"
      >
        <div class="mwow-button success">删除课次</div>
      </del-course-dialog>
      <range-selector
        range-type="day"
        @change="renderCalendar"
        @update="
          (t) => {
            timeRange = t.range;
          }
        "
        :show-select="false"
        :id="2"
      ></range-selector>
    </div>
    <div class="lc-title">
      共{{ dataTotal.total }}课次，已点名{{
        dataTotal.rollCallCount
      }}课次，未点名{{ dataTotal.notRollCallCount }}课次, 共{{
        dataTotal.rollcallStudentCount + dataTotal.notRollcallStudentCount || 0
      }}人次, 已点名{{ dataTotal.rollcallStudentCount }}人次,未点名{{
        dataTotal.notRollcallStudentCount
      }}人次
    </div>
    <div class="lc-content" v-loading="loading">
      <calendar
        :origin-events="calendarEvents"
        :origin-time-range="showTimeRange"
      >
        <template v-slot:default="slotProps">
          <div class="lc-event-week">
            <lesson-dialog
              :lid="slotProps.lesson.lesson_id"
              @change="handleDetailUpdate(slotProps.lesson.lesson_id)"
            >
              <div
                :style="`height:${
                  slotProps.type === 'static' ? '44' : slotProps.lesson.height
                }px;`"
              >
                <div class="event-reference">
                  <!-- <div class="tag-wrap">
                    <span
                      class="tag"
                      v-if="
                        slotProps.lesson.include_student_type.experience > 0
                      "
                      >体</span
                    >
                    <span
                      class="tag"
                      v-if="
                        slotProps.lesson.include_student_type.temporary > 0
                      "
                      >临</span
                    >
                    <span v-if="slotProps.lesson.roll_call_status === 2">
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .leave > 0
                        "
                        >假</span
                      >
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .absent > 0
                        "
                        >未</span
                      >
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .leave === 0 &&
                          slotProps.lesson.include_roll_call_student_status
                            .absent === 0
                        "
                        >点</span
                      >
                    </span>
                  </div> -->
                  <p class="time">
                    {{ slotProps.lesson.start_time.slice(0, 5) }} -
                    {{ slotProps.lesson.end_time.slice(0, 5) }}
                  </p>
                  <!-- <p v-if="slotProps.lesson.classroom">
                    {{slotProps.lesson.classroom.name}}
                  </p> -->
                  <!-- <p>
                    {{
                      slotProps.lesson.class.name && slotProps.lesson.class.name
                    }}
                  </p> -->
                  <p>
                    {{
                      slotProps.lesson.class.sub_name
                        ? slotProps.lesson.class.sub_name
                        : slotProps.lesson.class.name
                    }}
                  </p>
                  <p v-if="slotProps.lesson.teacher_list.length > 0">
                    {{
                      slotProps.lesson.teacher_list
                        .map((item) => {
                          return item.name;
                        })
                        .join("、")
                    }}
                  </p>
                  <div v-if="slotProps.lesson.student_list.length > 0">
                    <p
                      v-for="item in slotProps.lesson.student_list"
                      :key="item.student.student_id"
                      class="classroom-name"
                    >
                      <span v-if="item.student_type === 0">[正]</span>
                      <span v-if="item.student_type === 1">[临]</span>
                      <span v-if="item.student_type === 2">[调]</span>
                      <span v-if="item.student_type === 3">[补]</span>
                      <span v-if="item.student_type === 4">[约]</span>
                      <span v-if="item.student_type === 5">[体]</span>
                      <span>&nbsp; {{ item.student.name }}</span>
                      <span v-if="item.student_status === 0"
                        >&nbsp;-&nbsp;未签到</span
                      >
                      <span v-if="item.student_status === 1"
                        >&nbsp;-&nbsp;到课</span
                      >
                      <span v-if="item.student_status === 2"
                        >&nbsp;-&nbsp;迟到</span
                      >
                      <span v-if="item.student_status === 3"
                        >&nbsp;-&nbsp;请假</span
                      >
                      <span v-if="item.student_status === 4"
                        >&nbsp;-&nbsp;未到</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </lesson-dialog>
          </div>
        </template>
      </calendar>
    </div>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import { getCurrentWeek } from "@/utils/timeFormat";
import {
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import {
  lessonDetail,
  getRange,
  timeTable,
  timetableClassroomApi,
} from "@/api/schedule";
import { classroomSelectListApi } from "@/api/classRoom";
import lessonDialog from "../lessonDialog.vue";
import rangeSelector from "../lessonCalendar/rangeSelector.vue";
import calendar from "./calendar.vue";
import { mixin } from "@/mixin/tabPageInfoMixin";
import courseAdjustment from "@/components/courseAdjustment.vue";
import delCourseDialog from "@/components/delCourseDialog.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import schedulePrintDialog from "@/components/schedulePrintDialog.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  name: "lessonCalendar",
  components: {
    rangeSelector,
    calendar,
    lessonDialog,
    courseAdjustment,
    delCourseDialog,
    schedulePrintDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
  },
  mixins: [mixin],
  // @Prop() id!: number;
  props: ["id", "visible"],
  data() {
    return {
      searchInfo: {
        sub_name: "",
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        classroom_id: [],
        student_id: "",
        lesson_exercise: "-1",
        teacher_id: [],
        teacher_list: [],
      },
      showFormText: "展开",
      classList: [],
      SubClassList: [],
      courseClass: {},
      courseList: [],
      studentList: [],
      classroomList: [],
      timeRange: [], // 搜索筛选时间段
      calendarEvents: [],
      currentDialogLessonData: {
        class: {},
        class_lesson_extend: {
          content: "-",
        },
      },
      dataTotal: {
        total: 0,
        rollCallCount: 0,
        notRollCallCount: 0,
        rollcallStudentCount: 0,
        notRollcallStudentCount: 0,
      },
      lessonCache: {},
      showTimeRange: [], // 展示时间轴范围
      loading: false,
    };
  },
  mounted() {
    if (this.id !== 0) {
      this.searchInfo.classroom_id = [this.id];
    }
    this.mixinGetPageInfo("classroomTableSearch");
    eventBus.$on("schedule-range-change", (arr) => {
      this.showTimeRange = arr;
      this.renderCalendar();
    });
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  beforDestroy() {
    eventBus.$off("schedule-range-change");
  },
  methods: {
    init() {
      if (this.searchInfo.className) {
        this.handleSearchClass(this.searchInfo.className);
      }
      if (this.searchInfo.courseName) {
        this.handleSearchCourse(this.searchInfo.courseName);
      }
      if (this.searchInfo.studentName) {
        this.handleSearchStudent(this.searchInfo.studentName);
      }
      if (this.searchInfo.classroomName) {
        this.handleSearchClassroom(this.searchInfo.classroomName);
      }
      getRange().then((res) => {
        if (res.error_code === 0) {
          if (res.data.end_time === "00:00:00") {
            res.data.end_time = "23:55:00";
          }
          this.showTimeRange = [res.data.start_time, res.data.end_time];
          this.renderCalendar();
        }
      });
    },
    getTimeTableData() {
      const range = getCurrentWeek(this.timeRange[0]);
      const start = this.formatTime(range[0].getTime());
      const end = this.formatTime(range[1].getTime());
      const params = {
        start_date: start,
        end_date: end,
      };
      if (this.searchInfo.course_id) {
        params.course_ids = [this.searchInfo.course_id];
      }
      if (this.searchInfo.class_id) {
        params.class_ids = [this.searchInfo.class_id];
      }
      if (this.searchInfo.sub_name) {
        params.sub_name = this.searchInfo.sub_name;
      }
      if (this.searchInfo.teacher_id.length > 0) {
        params.teacher_ids = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.student_id) {
        params.student_ids = [this.searchInfo.student_id];
      }
      if (Number(this.searchInfo.lesson_type) >= 0) {
        params.lesson_type = Number(this.searchInfo.lesson_type);
      }
      if (Number(this.searchInfo.roll_call_status) >= 0) {
        params.roll_call_status = Number(this.searchInfo.roll_call_status);
      }
      if (Number(this.searchInfo.course_type) >= 0) {
        params.course_type = Number(this.searchInfo.course_type);
        if (Number(this.searchInfo.course_type) === 1) {
          if (Number(this.searchInfo.class_student_full) >= 0) {
            params.class_student_full = Number(
              this.searchInfo.class_student_full
            );
          }
        }
      }
      if (Number(this.searchInfo.student_type) >= 0) {
        params.student_type = Number(this.searchInfo.student_type);
      }
      if (Number(this.searchInfo.roll_call_student_status) >= 0) {
        params.roll_call_student_status = Number(
          this.searchInfo.roll_call_student_status
        );
      }
      if (
        this.searchInfo.classroom_id &&
        this.searchInfo.classroom_id.length > 0
      ) {
        params.classroom_ids = this.searchInfo.classroom_id;
      }
      params.simplify = false;
      return timeTable(params);
    },
    resetSearch() {
      this.searchInfo = {
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        classroom_id: [],
        lesson_exercise: "-1",
        teacher_id: [],
        teacher_list: [],
      };
      this.mixinSavePageInfo("classroomTableSearch");
      this.renderCalendar();
    },
    // 时间格式化
    formatTime(time) {
      const date = new Date(time);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 30,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
      this.searchInfo.className = v;
    },
    handleSearchClassBySub(v) {
      getSelectClassList({
        page: 1,
        page_size: 30,
        sub_name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            // 旧数据的班级没有 sub_name，默认使用 name 代替
            if (item.sub_name === "") {
              item.sub_name = item.name;
            }
          });
          this.SubClassList = res.data.list;
        }
      });
      this.searchInfo.class_sub = v;
    },
    handleSearchClassBySubVisible(rest) {
      if (rest) {
        this.handleSearchClassBySub("");
      }
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 50,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
      this.searchInfo.courseName = v;
    },
    handleSearchClassroom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classroomList = res.data.list;
        }
      });
      this.searchInfo.classroomName = v;
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
      this.searchInfo.studentName = v;
    },
    handleSearch() {
      this.renderCalendar();
      this.mixinSavePageInfo("classroomTableSearch");
    },
    // 渲染日历
    renderCalendar(data) {
      if (!this.visible) {
        return false;
      }
      let searchTime;
      if (data && data.range) {
        this.timeRange = data.range;
        searchTime = data.range;
      } else {
        searchTime = this.timeRange;
      }
      if (searchTime.length === 0) {
        return false;
      }
      const start = this.formatTime(searchTime[0]);
      const end = this.formatTime(searchTime[1]);
      const params = {
        start_date: start,
        end_date: end,
        publish_homework: 0,
      };
      if (this.searchInfo.course_id) {
        params.course_ids = [this.searchInfo.course_id];
      }
      if (this.searchInfo.class_id) {
        params.class_ids = [this.searchInfo.class_id];
      }
      // 使用简称过滤班级名称，再用班级名称查询表格数据
      if (this.searchInfo.class_sub) {
        params.class_ids = [this.searchInfo.class_sub];
      }
      if (this.searchInfo.teacher_id.length > 0) {
        params.teacher_ids = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.student_id) {
        params.student_ids = [this.searchInfo.student_id];
      }
      if (
        this.searchInfo.classroom_id &&
        this.searchInfo.classroom_id.length < 0
      ) {
        params.classroom_ids = this.searchInfo.classroom_id;
      }
      if (Number(this.searchInfo.lesson_type) >= 0) {
        params.lesson_type = Number(this.searchInfo.lesson_type);
      }
      if (Number(this.searchInfo.roll_call_status) >= 0) {
        params.roll_call_status = Number(this.searchInfo.roll_call_status);
      }
      if (Number(this.searchInfo.course_type) >= 0) {
        params.course_type = Number(this.searchInfo.course_type);
        if (Number(this.searchInfo.course_type) === 1) {
          if (Number(this.searchInfo.class_student_full) >= 0) {
            params.class_student_full = Number(
              this.searchInfo.class_student_full
            );
          }
        }
      }
      if (Number(this.searchInfo.student_type) >= 0) {
        params.student_type = Number(this.searchInfo.student_type);
      }
      if (Number(this.searchInfo.roll_call_student_status) >= 0) {
        params.roll_call_student_status = Number(
          this.searchInfo.roll_call_student_status
        );
      }
      if (Number(this.searchInfo.lesson_exercise) > 0) {
        params.publish_homework = Number(this.searchInfo.lesson_exercise);
      }
      this.loading = true;
      timetableClassroomApi(params)
        .then((res) => {
          this.loading = false;
          this.dataTotal = {
            total: res.data.total,
            rollCallCount: res.data.roll_call_count,
            notRollCallCount: res.data.not_roll_call_count,
            rollcallStudentCount: res.data.roll_call_student_count,
            notRollcallStudentCount: res.data.not_roll_call_student_count,
          };
          this.calendarEvents = res.data.classroom_list;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getLessonInfo(lesson) {
      const id = lesson.lesson_id;
      // 课次信息缓存
      if (this.lessonCache[id]) {
        this.currentDialogLessonData = this.lessonCache[id];
        this.courseClass = this.lessonCache[id].class;
      } else {
        lessonDetail({
          lesson_id: id,
        }).then((res) => {
          this.courseClass = res.data.class;
          const arr = [];
          const arr1 = [];
          const arr3 = [];
          const arr4 = [];
          if (lesson.roll_call_status === 2) {
            res.data.roll_call_student_list.map((item) => {
              if (item.student_status === 1) {
                arr1.push(item.student.name);
              }
              if (item.student_status === 2) {
                arr1.push(item.student.name);
              }
              if (item.student_status === 3) {
                arr3.push(item.student.name);
              }
              if (item.student_status === 4) {
                arr4.push(item.student.name);
              }
            });
          } else {
            res.data.student_list.map((item) => {
              arr.push(item.name);
            });
          }
          lesson.class.current_student_count =
            res.data.class.current_student_count;
          lesson.class.preset_student_count =
            res.data.class.preset_student_count;
          const result = {
            ...res.data,
            studentString: arr.join(","),
            studentString1: arr1.join(","),
            studentString3: arr3.join(","),
            studentString4: arr4.join(","),
          };
          this.currentDialogLessonData = result;
          if (result.class_lesson_extend.content) {
            this.currentDialogLessonData.class_lesson_extend.content =
              result.class_lesson_extend.content;
          }
          this.lessonCache[id] = result;
        });
      }
    },
    toRollCall(rid, lid) {
      if (!rid) {
        this.$router.push({
          name: "classTimeDetails",
          query: { id: String(lid) },
        });
      } else {
        this.$router.push({
          name: "rollCallDetails",
          query: { id: String(rid) },
        });
      }
    },
    handleDetailUpdate(lid) {
      // 课次详情更新后删除详情缓存，重新渲染表格
      const copy = { ...this.lessonCache };
      delete copy[lid];
      this.lessonCache = copy;
      this.renderCalendar();
    },
  },
};
</script>
<style lang="scss" scoped>
.lc-container {
  background: #ffffff;
  .form-wrap {
    position: relative;
    overflow: hidden;
    transition: height 300ms ease-in-out;
    padding-right: 20px;
  }
  .lc-header {
    margin-bottom: 12px;
    position: relative;
    .float-print-wrap {
      position: absolute;
      bottom: 2px;
      left: 0;
      z-index: 100;
    }
    .l1 {
      left: 85px;
    }
    .l2 {
      left: 170px;
      display: flex;
      align-items: center;
    }
  }
  .lc-title {
    margin-bottom: 12px;
    height: 28px;
    background: #fff7e9;
    border-radius: 4px;
    font-size: 12px;
    line-height: 28px;
    color: #5c5d5e;
    padding: 0 10px;
  }
  .lc-content {
    .tab-wrap {
      height: 100%;
    }
    .lc-event-month {
      font-size: 12px;
      color: #fff;
      line-height: 18px;
      margin-bottom: 3px;
      position: relative;
      .tag-wrap {
        position: absolute;
        top: 0;
        right: 0;
        .tag {
          display: inline-block;
          vertical-align: top;
          font-size: 12px;
          line-height: 12px;
          padding: 4px 3px;
          background-color: #888888;
          border-bottom-left-radius: 20%;
          border-bottom-right-radius: 20%;
          transform: scale(0.8);
          transform-origin: right top;
        }
      }
      .time {
        padding-right: 24px;
      }
      p {
        line-height: 18px;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .el-popover__reference {
        padding: 3px 8px;
      }
    }
    .lc-event-week,
    .lc-event-day {
      height: 100%;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      .event-reference {
        height: 100%;
        // box-sizing: border-box;
        padding: 3px 8px;
        position: relative;
        margin-bottom: 2px;
        // border-right: 1px solid #eee;
        // border-bottom: 1px solid #eee;
      }
      .tag-wrap {
        position: absolute;
        top: 0;
        right: 0;
        .tag {
          display: inline-block;
          vertical-align: top;
          font-size: 12px;
          line-height: 12px;
          padding: 4px 3px;
          background-color: #888888;
          border-bottom-left-radius: 20%;
          border-bottom-right-radius: 20%;
          transform: scale(0.8);
          transform-origin: right top;
        }
      }
      .time {
        padding-right: 24px;
      }
      p {
        line-height: 18px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.event-hover-dialog {
  margin: -12px;
  .content {
    padding: 12px;
    color: #5c5d5e;
    .p1 {
      font-size: 13px;
      line-height: 22px;
      span {
        vertical-align: baseline;
      }
      img {
        vertical-align: middle;
        margin-left: 6px;
      }
      .roll-tag {
        vertical-align: baseline;
        background-color: #888888;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 12px;
        padding: 2px 4px;
        margin-left: 10px;
      }
    }
    .p2 {
      font-size: 12px;
      line-height: 22px;
      border-top: 1px solid #cbcbcb;
      padding-top: 8px;
      margin-top: 4px;
    }
    .p3 {
      font-size: 12px;
      line-height: 22px;
      border-top: 1px solid #cbcbcb;
      padding-top: 4px;
      margin-top: 4px;
    }
    .p5 {
      display: flex;
      font-size: 13px;
      span {
        flex: 1;
      }
    }
  }
  .btns {
    display: flex;
    .btn {
      flex: 1;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &.green {
        color: #07d1aa;
        background: #f0fdfa;
      }
      &.gray {
        color: #5c5d5e;
        background: #f1f1f1;
      }
      &.blue {
        color: #32bdf3;
        background: #eaf8fd;
      }
    }
  }
}
/deep/.el-form {
  .el-form-item {
    margin-right: 38px;
    .el-select {
      width: 100%;
      .el-select__tags {
        width: 100%;
        display: flex;
        max-width: 161px;
        flex-wrap: nowrap;
        overflow-x: auto;
        &::-webkit-scrollbar {
          width: 4px;
          height: 1px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #d8d8d8;
          border-radius: 2px;
        }
      }
    }
  }
}
.classroom-name {
  white-space: pre-wrap !important;
  max-width: 200px !important;
}
</style>
